<template>

  <a :href="href" target="_blank" rel="external" class="text-decoration-none">
    <span class="text-decoration-underline"><slot /></span>&nbsp;<v-icon icon="$newWindow" size="x-small"></v-icon>
  </a>


</template>

<script setup lang="ts">

interface Props {
  href: string
}

defineProps<Props>()

</script>
